import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import type {LotesResumen} from '@/lib/bateria'

/**
 * La cola congelada (v2 §3.6) no abre mientras el lote se lee: sembraría tarjetas que el sistema
 * resuelve segundos después. Un lote detenido (10 min sin avance) deja pasar.
 */
export function LoteLeyendo({lotes, volverA}: {lotes: LotesResumen; volverA: string}) {
  const {t} = useTranslation()
  return (
    <section className="notice-amber space-y-3 rounded-lg px-5 py-4" data-testid="cola-lote-leyendo">
      <p className="text-sm font-medium">{t('admin.bateria.cola.leyendo.titulo')}</p>
      <p className="text-sm">
        {t('admin.bateria.cola.leyendo.cuerpo', {
          porProcesar: lotes.porProcesar,
          leidas: lotes.leidas,
          sinUbicar: lotes.sinUbicar,
        })}
      </p>
      <Button asChild variant="outline" className="min-h-11 md:min-h-0" data-testid="cola-lote-leyendo-volver">
        <Link to={volverA}>{t('admin.bateria.cola.volver')}</Link>
      </Button>
    </section>
  )
}
